import { Planning } from '@obo-main/services/plannings/plannings.models';

export class Project {
    public id: number;
    public name: string;
    public abbreviation: string;
    public creationDate: Date;
    public customerName: string;
    public customerNumber: string;
    public modificationDate: string;
    public number: string;
    public orderDate: string;
    public isReadOnly: boolean;
    public usageDate: string;
    public buildingCount: number;
    public plannedModules: number[];
}

export class Location {
    public address: string;
    public regionId: number;
    public latitude: number;
    public longitude: number;

    constructor(location?: Location) {
        if (location) {
            this.address = location.address;
            this.regionId = location.regionId;
            this.latitude = location.latitude;
            this.longitude = location.longitude;
        }
    }

    public toLatLng(): google.maps.LatLng {
        return new google.maps.LatLng(this.latitude, this.longitude);
    }
}

export class Building extends Location {
    public id: number;
    public name: string;
    public plannings: ExtendedPlanning[];
    public usageDate: string;
}

export enum ModelUpdateAction {
    Create = 'Create',
    Update = 'Update',
    Delete = 'Delete'
}

export class ExtendedPlanning extends Planning {
    public planningState: string;
    public planningTileUrl: string;
}
